import Box from '@mui/material/Box';
import {bool} from 'prop-types';

const SidebarSeparatorShadow = ({isAbsolutePositionned = false}) => (
  <Box
    sx={{
      ...(isAbsolutePositionned
        ? {
            position: 'absolute',
            bottom: -3
          }
        : {}),
      height: 3,
      width: 80,
      boxShadow: '0px -4px 4px rgba(0, 0, 0, 0.25)'
    }}
  />
);

SidebarSeparatorShadow.propTypes = {
  isAbsolutePositionned: bool
};

export default SidebarSeparatorShadow;
